const theme = {
    colors: {
      highlight: '#7289da',
      redHighlight: '#e042e6',
      lighterHighlight: '#4a6be6',
      text: '#ffffff',
      softBlueGrey: '#99aab5',
      dark: '#2c2f33',
      darker: '#23272a',
    orange: '#FFA500;',
      container: '#27405a',
      background: '#20272e',
      darkbackground: 'rgba(0, 0, 0, 0.5)',
    },
  };
  
  export default theme;